/* eslint-disable import/prefer-default-export */
const defaultObj = {};

export const getUserAdditionalInfo = (state) => state.UserAdditionalInfo.userAdditionalInfo || defaultObj;
export const getLoadingAdditionalInfo = (state) => state.UserAdditionalInfo.loadingAdditionalInfo || false;
